import script from "./compare-table-mobile.vue?vue&type=script&setup=true&lang=js"
export * from "./compare-table-mobile.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__